/** @file requireProfile: throws PROFILE_UNKNOWN at the input path unless the context knows the profile. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import { throwError } from '@zilo/pose3d-std/errors/throwError';
import type { CommandContext } from '../context/commandContext';

/** Returns `profile` when `ctx.profiles` has it; the hint lists the known profiles. */
export function requireProfile(profile: string, ctx: Pick<CommandContext, 'profiles'>, path = '/input/profile'): string {
  if (Object.hasOwn(ctx.profiles, profile)) return profile;
  return throwError(ERROR_CODES.PROFILE_UNKNOWN, { profile }, { path, hint: `profiles: ${Object.keys(ctx.profiles).join(', ')}` });
}
